import {
  BooleanParam,
  decodeDelimitedArray,
  DecodedValueMap,
  encodeDelimitedArray,
  NumberParam,
  SetQuery,
  StringParam,
  useQueryParams,
} from 'use-query-params';

export const DELIMITED_ARRAY_SEPARATOR = ',';
export const CommaDelimitedParam = {
  encode: (array: (string | null)[] | null | undefined) => encodeDelimitedArray(array, DELIMITED_ARRAY_SEPARATOR),
  decode: (arrayStr: string | (string | null)[] | null | undefined) =>
    decodeDelimitedArray(arrayStr, DELIMITED_ARRAY_SEPARATOR),
};

const filterQueryParams = {
  countries: CommaDelimitedParam,
  trigrams: CommaDelimitedParam,
  tribes: CommaDelimitedParam,
  criticalities: CommaDelimitedParam,
  applicationTypes: CommaDelimitedParam,
  tags: CommaDelimitedParam,
  status: CommaDelimitedParam,
  query: StringParam,
  sort: StringParam,
  order: StringParam,
  resultSort: StringParam,
  resultOrder: StringParam,
  resultValue: StringParam,
  managedBy: CommaDelimitedParam,
  portfolio: CommaDelimitedParam,
  componentStatus: CommaDelimitedParam,
  names: CommaDelimitedParam,
  periodView: StringParam,
  architectureTypes: CommaDelimitedParam,
  functionalArchitecture: CommaDelimitedParam,
  isAmerManaged: StringParam,
  isCertified: StringParam,
  isInternetExposed: StringParam,
  languages: CommaDelimitedParam,
  record: StringParam,
  idType: StringParam,
  presenceResults: CommaDelimitedParam,
  novaCompatibility: CommaDelimitedParam,
  ownedBy: CommaDelimitedParam,
  infrastructureComponent: CommaDelimitedParam,
  obsolescenceDate: StringParam,
  scopeResults: CommaDelimitedParam,
  remediations: CommaDelimitedParam,
  ownershipRc: CommaDelimitedParam,
  managementRc: CommaDelimitedParam,
  remediationStatus: CommaDelimitedParam,
  remediationTarget: CommaDelimitedParam,
  remediationQuery: StringParam,
  remediationComponents: CommaDelimitedParam,
  iam: CommaDelimitedParam,
  recommendationComponents: CommaDelimitedParam,
  assetZones: CommaDelimitedParam,
  applicationRemediations: CommaDelimitedParam,
  enablers: CommaDelimitedParam,
  applicationRegulations: CommaDelimitedParam,
};

const recordQueryParams = {
  recordFrom: StringParam,
  recordTo: StringParam,
};

const paginationQueryParams = {
  page: NumberParam,
  limit: NumberParam,
  minePage: NumberParam,
  favoritesPage: NumberParam,
  favoritesLimit: NumberParam,
  mineLimit: NumberParam,
};

const complianceQueryParams = {
  scopeRefId: StringParam,
  scopeRefName: StringParam,
  componentRefType: StringParam,
  componentRefId: StringParam,
  versionRefId: StringParam,
  recommendationTitle: StringParam,
  recommendationStatus: StringParam,
  recommendationDueDate: StringParam,
  roadmapAssets: StringParam,
  roadmapComment: StringParam,
  roadmapExpectedDate: StringParam,
  selectedAssetName: StringParam,
  exceptionComment: StringParam,
  complianceAndRegulation: StringParam,
  components: CommaDelimitedParam,
  inventoryView: StringParam,
  kpiView: StringParam,
  obsolescenceView: StringParam,
  obsolescenceDateKpi: StringParam,
  complianceSort: StringParam,
  exceptionAssets: StringParam,
  version: StringParam,
  criticalities: CommaDelimitedParam,
  assetZones: CommaDelimitedParam,
  portfolio: CommaDelimitedParam,
  isInternetExposed: StringParam,
};

const UIQueryParams = {
  applicationView: StringParam,
  periodView: StringParam,
  modal: BooleanParam,
  evolutionCostModal: BooleanParam,
  healthTotalModal: BooleanParam,
  totalCostModal: BooleanParam,
  totalModal: BooleanParam,
  applicationId: NumberParam,
  applicationName: StringParam,
  scope: StringParam,
  parent: StringParam,
  date: StringParam,
  bookmarkModal: BooleanParam,
  appView: StringParam,
  settings: BooleanParam,
  view: StringParam,
  totalView: StringParam,
  currentView: StringParam,
  componentModal: BooleanParam,
  roadmapScope: StringParam,
  remediationModal: BooleanParam,
  component: StringParam,
  remediationRoadmapId: NumberParam,
  remediationExceptionId: NumberParam,
  remediationFromMail: BooleanParam,
  recommendationId: NumberParam,
  roadmapEditModal: BooleanParam,
  exceptionEditModal: BooleanParam,
  remediationFilter: StringParam,
  hideDecommissionedAssets: BooleanParam,
};

const inventoryQueryParams = {
  ownershipRC: StringParam,
  componentRefType: StringParam,
  componentRefName: StringParam,
  version: StringParam,
  advisedVersion: StringParam,
  assetServerCloudType: StringParam,
  assetNumberOfCores: StringParam,
  assetInstalledMemory: StringParam,
  assetNumberOfLogicalCpu: StringParam,
  assetServerStatus: StringParam,
  assetServerEnvironment: StringParam,
  assetServerServiceOffer: StringParam,
  assetHostname: StringParam,
  assetName: StringParam,
  assetZone: StringParam,
  assetUid: StringParam,
  eolSupport: StringParam,
  eolDate: StringParam,
  roadmapExpectedDate: StringParam,
  roadmapComment: StringParam,
  exceptionComment: StringParam,
  ITRMObsolescenceStatus: StringParam,
  recommendationStatus: StringParam,
  applicationCriticality: StringParam,
  criticalities: CommaDelimitedParam,
  applicationTypes: CommaDelimitedParam,
  kearID: StringParam,
  isCBS: StringParam,
  isManagedByGTS: StringParam,
  complianceAndRegulation: StringParam,
  assetTransformationPath: StringParam,
  assetTransformationTarget: StringParam,
  applicationTransformationPath: StringParam,
  applicationTransformationTarget: StringParam,
  applicationAustinEndDate: StringParam,
  assetServerCountry: StringParam,
  assetServerExposed: StringParam,
  portfolio: CommaDelimitedParam,
  assetServerSubnetName: StringParam,
  applicationRegulations: StringParam,
  isInternetExposed: StringParam,
  roadmapExpectedDate2: StringParam,
  recommendationStatus2: StringParam,
  recommendationType: StringParam,
  recommendationType2: StringParam,
  roadmapComment2: StringParam,
  exceptionComment2: StringParam,
};

const recommendationTableQueryParams = {
  recommendationCriticity: CommaDelimitedParam,
  recommendationComponentRefId: NumberParam,
  recommendationVersionRefId: NumberParam,
  recommendationFilter: StringParam,
};

const thirdpartySoftwareQueryParams = {
  trigram: StringParam,
  mainApplication: StringParam,
  applicationManager: StringParam,
  publisher: StringParam,
  product: StringParam,
  tpsName: StringParam,
  tpsVersion: StringParam,
  edition: StringParam,
  classification: StringParam,
  isUsed: StringParam,
  lastUsedDate: StringParam,
  installDate: StringParam,
  inventoryDate: StringParam,
  tpsStatus: StringParam,
  computerName: StringParam,
  type: StringParam,
  domain: StringParam,
  os: StringParam,
  ip: StringParam,
  role: StringParam,
  iAppliCode: StringParam,
  irtCode: StringParam,
  developmentManager: StringParam,
  domainManager: StringParam,
  dsi: StringParam,
  location: StringParam,
  tpsSearch: StringParam,
};

const obsolescenceQueryParams = {
  obsolescencePage: NumberParam,
  obsolescenceLimit: NumberParam,
  obsolescenceSort: StringParam,
  obsolescenceFilter: StringParam,
  obsolescenceHardware: BooleanParam,
};

const queryParams = {
  ...filterQueryParams,
  ...recordQueryParams,
  ...paginationQueryParams,
  ...complianceQueryParams,
  ...UIQueryParams,
  ...inventoryQueryParams,
  ...recommendationTableQueryParams,
  ...thirdpartySoftwareQueryParams,
  ...obsolescenceQueryParams,
};

export type AvailableQueryParamKey = keyof typeof queryParams;
export type FilterQueryParams = DecodedValueMap<typeof filterQueryParams>;
export type RecordQueryParams = DecodedValueMap<typeof recordQueryParams>;
export type ComplianceQueryParams = DecodedValueMap<typeof complianceQueryParams>;
export type InventoryQueryParams = DecodedValueMap<typeof inventoryQueryParams>;
export type RecommendationTableQueryParams = DecodedValueMap<typeof recommendationTableQueryParams>;
export type ThirdpartySoftwareQueryParams = DecodedValueMap<typeof thirdpartySoftwareQueryParams>;

export const FILTER_QUERY_PARAM_KEYS = Object.keys(filterQueryParams) as (keyof FilterQueryParams)[];
export const COMPLIANCE_QUERY_PARAM_KEYS = Object.keys(filterQueryParams) as (keyof ComplianceQueryParams)[];
export const PAGINATION_QUERY_PARAM_KEYS = Object.keys(paginationQueryParams) as (keyof DecodedValueMap<
  typeof paginationQueryParams
>)[];
export const RECORD_QUERY_PARAM_KEYS = Object.keys(recordQueryParams) as (keyof DecodedValueMap<
  typeof recordQueryParams
>)[];
export const UI_QUERY_PARAM_KEYS = Object.keys(UIQueryParams) as (keyof DecodedValueMap<typeof UIQueryParams>)[];

export const INVENTORY_QUERY_PARAM_KEYS = Object.keys(inventoryQueryParams) as (keyof DecodedValueMap<
  typeof inventoryQueryParams
>)[];
export const OBSOLESCENCE_QUERY_PARAM_KEYS = Object.keys(obsolescenceQueryParams) as (keyof DecodedValueMap<
  typeof obsolescenceQueryParams
>)[];
export const RECOMMENDATION_TABLE_QUERY_PARAM_KEYS = Object.keys(
  recommendationTableQueryParams
) as (keyof DecodedValueMap<typeof recommendationTableQueryParams>)[];
export const THIRD_PARTY_SOFTWARE_QUERY_PARAM_KEYS = Object.keys(
  thirdpartySoftwareQueryParams
) as (keyof DecodedValueMap<typeof thirdpartySoftwareQueryParams>)[];
export const ALL_QUERY_PARAM_KEYS = [
  ...FILTER_QUERY_PARAM_KEYS,
  ...COMPLIANCE_QUERY_PARAM_KEYS,
  ...PAGINATION_QUERY_PARAM_KEYS,
  ...RECORD_QUERY_PARAM_KEYS,
  ...UI_QUERY_PARAM_KEYS,
  ...INVENTORY_QUERY_PARAM_KEYS,
  ...RECOMMENDATION_TABLE_QUERY_PARAM_KEYS,
  ...THIRD_PARTY_SOFTWARE_QUERY_PARAM_KEYS,
  ...OBSOLESCENCE_QUERY_PARAM_KEYS,
] as const;

/**
 * High-Order Component to encapsulate the use of query params inside the component
 * Component will inherite 2 new props : queryParams and setQueryParams
 * Can be use as the following :
 *
 * const MyComponent = withQueryParams<
 *  { myProp: string },
 *  ['applicationId']
 * >(
 *  ['applicationId'],
 *  ({ myProp, queryParams, setQueryParams }) => {
 *  return <></>
 * })
 */
export const withQueryParams = <T, U extends readonly (keyof typeof queryParams)[]>(
  selectedQueryParamKeys: U,
  WrappedComponent: React.FC<
    T & {
      queryParams: DecodedValueMap<{ [key in U[number]]: (typeof queryParams)[key] }>;
      setQueryParams: SetQuery<{ [key in U[number]]: (typeof queryParams)[key] }>;
    }
  >
) => {
  const selectedQueryParams = selectedQueryParamKeys.reduce((acc, curr) => ({ ...acc, [curr]: queryParams[curr] }), {});
  // We could memoize the component here

  return (props: T) => {
    const [queryParams, setQueryParams] = useQueryParams(selectedQueryParams);

    return <WrappedComponent {...props} queryParams={queryParams as any} setQueryParams={setQueryParams} />;
  };
};
